/* Folded Wisdom theme: vanilla JS. Uses Shopify's real cart endpoints. */
(() => {
  const T = window.theme;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (c) => new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: T.currency }).format(c / 100);

  /* dialogs (mobile nav, search, filters, cart drawer) */
  const openDialog = (d) => {
    if (!d || d.open) return;
    d.classList.remove('is-closing');
    d.showModal();
    document.documentElement.classList.add('lock');
  };
  const closeDialog = (d) => {
    if (!d || !d.open) return;
    if (reduced()) return d.close();
    d.classList.add('is-closing');
    d.addEventListener('animationend', () => { d.close(); d.classList.remove('is-closing'); }, { once: true });
  };
  const bindDialogs = (root) => $$('dialog', root).forEach((d) => {
    if (d.dataset.bound) return;
    d.dataset.bound = '1';
    d.addEventListener('close', () => document.documentElement.classList.remove('lock'));
  });

  /* cart */
  let busy = false;
  const setBusy = (b) => { busy = b; document.documentElement.classList.toggle('cart-busy', b); };
  const cartError = (m) => { const el = $('[data-cart-error]'); if (el) { el.textContent = m || ''; el.hidden = !m; } };

  async function renderDrawer(cart) {
    const res = await fetch(`${T.routes.root}?sections=cart-drawer`);
    if (!res.ok) throw new Error(T.strings.error);
    const json = await res.json();
    const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
    const next = $('[data-cart-drawer-body]', doc);
    const cur = $('[data-cart-drawer-body]');
    if (next && cur) cur.replaceWith(next);
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
  }
  const openCart = () => openDialog($('#cart-drawer'));

  async function changeLine(line, quantity) {
    if (busy) return;
    setBusy(true);
    try {
      const r = await fetch(T.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      const d = await r.json();
      if (!r.ok || d.status) throw new Error(d.description || d.message || T.strings.error);
      await renderDrawer(d);
      const it = d.items[line - 1];
      if (quantity > 0 && it && it.quantity < quantity) cartError(T.strings.maxQty);
    } catch (e) { cartError(e.message || T.strings.error); }
    finally { setBusy(false); }
  }

  async function addToCart(form) {
    const btn = $('[data-add]', form), label = $('[data-add-label]', form), err = $('[data-error]', form);
    const idInput = $('[data-variant-id]', form);
    if (!idInput || idInput.disabled || !idInput.value) return;
    const prev = label.textContent;
    btn.disabled = true; label.textContent = 'Adding'; err.hidden = true;
    try {
      const fd = new FormData(form);
      $$('fieldset[data-option] input', form).forEach((i) => fd.delete(i.name));
      const r = await fetch(T.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const d = await r.json();
      if (!r.ok || d.status) throw new Error(d.description || d.message || T.strings.error);
      if (T.cartType === 'drawer' && $('#cart-drawer')) {
        const cart = await (await fetch(T.routes.cartJs)).json();
        await renderDrawer(cart);
        openCart();
      } else { window.location.href = T.routes.cart; return; }
    } catch (e) { err.textContent = e.message || T.strings.error; err.hidden = false; }
    finally { btn.disabled = false; label.textContent = prev; }
  }

  /* quick add from product cards */
  async function quickAdd(btn) {
    if (busy || btn.disabled) return;
    const label = $('[data-qa-label]', btn.closest('[data-qa]') || document);
    const prevText = btn.textContent, prevLabel = label ? label.textContent : '';
    btn.disabled = true;
    try {
      const r = await fetch(T.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: parseInt(btn.dataset.quickAdd, 10), quantity: 1 }) });
      const d = await r.json();
      if (!r.ok || d.status) throw new Error(d.description || d.message || T.strings.error);
      if (T.cartType === 'drawer' && $('#cart-drawer')) {
        const cart = await (await fetch(T.routes.cartJs)).json();
        await renderDrawer(cart);
        openCart();
        btn.textContent = 'Added';
      } else { window.location.href = T.routes.cart; return; }
    } catch (e) {
      if (label) label.textContent = e.message || T.strings.error;
    } finally {
      setTimeout(() => { btn.textContent = prevText; btn.disabled = false; if (label) label.textContent = prevLabel; }, 1600);
    }
  }

  /* product page: variant selection */
  function initProduct(sec) {
    if (sec.dataset.ready) return;
    sec.dataset.ready = '1';
    const form = $('[data-product-form]', sec);
    const data = JSON.parse($('[data-variants]', sec).textContent);
    const sets = $$('fieldset[data-option]', form);
    const idIn = $('[data-variant-id]', form), btn = $('[data-add]', form), label = $('[data-add-label]', form);
    const price = $('[data-price]', sec);
    const priceHTML = (p, c) => c && c > p
      ? `<p class="price price--sale"><s class="price__was"><span class="vh">Regular price </span>${money(c)}</s><span class="vh">Sale price </span><span class="price__now">${money(p)}</span></p>`
      : `<p class="price"><span class="price__now">${money(p)}</span></p>`;
    const match = (sel) => data.find((v) => sel.every((s, i) => v['option' + (i + 1)] === s));

    const update = (scroll) => {
      const sel = sets.map((f) => { const c = $('input:checked', f); return c ? c.value : null; });
      sets.forEach((f, i) => { const l = $('[data-option-label]', f); if (l) l.textContent = sel[i] || ''; });
      sets.forEach((f, i) => $$('input', f).forEach((inp) => {
        const cand = sel.slice(); cand[i] = inp.value;
        const ok = data.some((v) => cand.every((s, j) => v['option' + (j + 1)] === s) && v.available);
        if (ok) inp.removeAttribute('data-out'); else inp.setAttribute('data-out', '1');
      }));
      const v = match(sel);
      if (!v) { idIn.disabled = true; btn.disabled = true; label.textContent = T.strings.unavailable; return; }
      idIn.value = v.id; idIn.disabled = !v.available; btn.disabled = !v.available;
      label.textContent = v.available ? T.strings.add : T.strings.soldOut;
      price.innerHTML = priceHTML(v.price, v.compare_at_price);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      const extras = $$('[data-extra]', sec);
      if (extras.length) {
        const want = v.featured_media ? String(v.featured_media.id) : '';
        extras.forEach((el) => { el.hidden = el.dataset.mediaId !== want; });
        const gal = $('[data-gallery]', sec);
        if (gal) gal.dispatchEvent(new Event('gallery:refresh'));
      }
      if (scroll && v.featured_media) {
        const m = $(`[data-media-id="${v.featured_media.id}"]`, sec);
        if (m) {
          const track = m.closest('[data-gallery-track]');
          if (track && track.scrollWidth > track.clientWidth + 2) track.scrollTo({ left: m.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: reduced() ? 'auto' : 'smooth' });
          else m.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'nearest' });
          m.classList.remove('is-picked'); void m.offsetWidth; m.classList.add('is-picked');
        }
      }
    };
    if (sets.length) { sets.forEach((f) => f.addEventListener('change', () => update(true))); update(false); }

    form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(form); });
    $$('[data-step]', form).forEach((b) => b.addEventListener('click', () => {
      const q = $('input[name=quantity]', form);
      q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.step, 10));
    }));
  }

  /* product gallery: swipe on phones eases each photo in and out; desktop photos reveal on scroll */
  function initGallery(g) {
    if (g.dataset.ready) return;
    g.dataset.ready = '1';
    const track = $('[data-gallery-track]', g);
    const all = $$('[data-gallery-item]', g);
    const cur = $('[data-gallery-cur]', g), bar = $('[data-gallery-bar]', g), tot = $('[data-gallery-total]', g);
    if (!track || all.length < 2) return;
    let items = all;
    const refresh = () => {
      items = all.filter((it) => !it.hidden);
      if (tot) tot.textContent = items.length;
      if (bar) bar.style.width = (100 / Math.max(items.length, 1)) + '%';
    };
    g.addEventListener('gallery:refresh', () => { refresh(); queue(); });
    refresh();
    const mq = matchMedia('(max-width: 989px)');
    let raf = 0;
    const paint = () => {
      raf = 0;
      if (!mq.matches) { items.forEach((it) => { it.style.removeProperty('--g'); it.style.removeProperty('--gs'); }); return; }
      const box = track.getBoundingClientRect();
      const mid = box.left + parseFloat(getComputedStyle(track).paddingLeft || 0);
      let best = 0, bestD = Infinity;
      items.forEach((it, i) => {
        const r = it.getBoundingClientRect();
        const d = (r.left - mid) / r.width;           /* 0 when the photo is in place */
        const a = Math.min(Math.abs(d), 1);
        it.style.setProperty('--g', a.toFixed(3));
        it.style.setProperty('--gs', Math.max(-1, Math.min(1, d)).toFixed(3));
        if (Math.abs(d) < bestD) { bestD = Math.abs(d); best = i; }
      });
      if (cur) cur.textContent = best + 1;
      if (bar) bar.style.transform = `translateX(${best * 100}%)`;
    };
    function queue() { if (!raf) raf = requestAnimationFrame(paint); }
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (mq.addEventListener) mq.addEventListener('change', queue);
    paint();
  }

  /* related products (Shopify recommendations endpoint) */
  async function initRecs(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    try {
      const r = await fetch(el.dataset.url);
      if (!r.ok) return;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const n = $('[data-recs]', doc);
      if (n && n.innerHTML.trim()) el.innerHTML = n.innerHTML;
    } catch (e) { /* recommendations are optional */ }
  }

  /* reveals */
  const io = 'IntersectionObserver' in window && !reduced()
    ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: .15 })
    : null;
  const initReveal = (root) => $$('[data-reveal]', root).forEach((el) => { if (io) io.observe(el); else el.classList.add('is-in'); });

  const init = (root = document) => {
    bindDialogs(root);
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-gallery]', root).forEach(initGallery);
    $$('[data-recs]', root).forEach(initRecs);
    initReveal(root);
    $$('[data-autosubmit]', root).forEach((s) => { if (!s.dataset.bound) { s.dataset.bound = '1'; s.addEventListener('change', () => s.form && s.form.requestSubmit()); } });
    $$('[data-autosubmit-cart]', root).forEach((i) => { if (!i.dataset.bound) { i.dataset.bound = '1'; i.addEventListener('change', () => { const f = i.form; const u = $('[data-cart-update]', f); f.requestSubmit(u); }); } });
  };

  document.addEventListener('click', (e) => {
    const t = e.target;
    const o = t.closest('[data-dialog-open]');
    if (o) { e.preventDefault(); return openDialog(document.getElementById(o.dataset.dialogOpen)); }
    const c = t.closest('[data-dialog-close]');
    if (c) return closeDialog(c.closest('dialog'));
    if (t.matches && t.matches('dialog.drawer, dialog.search')) return closeDialog(t);
    const cart = t.closest('[data-cart-open]');
    if (cart && T.cartType === 'drawer' && $('#cart-drawer')) { e.preventDefault(); return openCart(); }
    const qa = t.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); return quickAdd(qa); }
    const tg = t.closest('[data-qa-toggle]');
    if (tg) { const c = tg.closest('.card'); const on = c.classList.toggle('is-open'); tg.setAttribute('aria-expanded', on); return; }
    const q = t.closest('#cart-drawer [data-qty]');
    if (q) { e.preventDefault(); changeLine(parseInt(q.dataset.line, 10), parseInt(q.dataset.qty, 10)); }
  });

  /* homepage intro: plays the chrome swan video, waits for the hero image, then pushes through */
  const runIntro = () => {
    const root = document.documentElement, intro = $('#intro');
    if (!intro || !root.classList.contains('has-intro')) return;
    const video = $('.intro__video', intro);
    const evts = ['click', 'keydown'];
    let out = false;
    const exit = () => {
      if (out) return;
      out = true;
      evts.forEach((t) => window.removeEventListener(t, exit));
      intro.classList.add('is-out');
      setTimeout(() => root.classList.add('intro-done'), 300);
      setTimeout(() => { intro.remove(); root.classList.remove('has-intro'); }, 800);
    };
    evts.forEach((t) => window.addEventListener(t, exit));
    const hero = $('.hero__media img');
    const heroReady = new Promise((res) => {
      const decode = () => (hero.decode ? hero.decode().catch(() => {}).then(res) : res());
      if (!hero) return res();
      if (hero.complete) decode(); else { hero.addEventListener('load', decode, { once: true }); hero.addEventListener('error', res, { once: true }); }
    });
    const played = new Promise((res) => {
      if (!video) return res();
      video.addEventListener('ended', res, { once: true });
      video.addEventListener('error', res, { once: true });
      video.addEventListener('playing', () => intro.classList.add('is-playing'), { once: true });
      let started = false;
      const start = () => {
        if (started) return;
        started = true;
        try { video.currentTime = 0; } catch (e) {}
        const p = video.play();
        if (p && p.catch) p.catch(res);
      };
      /* only start once the whole clip is buffered, so it never stalls half way */
      if (video.readyState >= 4) start();
      else {
        video.addEventListener('canplaythrough', start, { once: true });
        setTimeout(start, 2500);
      }
    });
    const limit = new Promise((res) => setTimeout(res, 7000));
    Promise.race([Promise.all([heroReady, played]), limit]).then(exit);
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const y = window.scrollY;
      document.body.classList.toggle('hdr-solid', y > 24);
      document.body.style.setProperty('--hdr-p', Math.min(y / 160, 1).toFixed(3));
      ticking = false;
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  document.addEventListener('DOMContentLoaded', () => { init(); onScroll(); runIntro(); });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
